module.exports = __webpack_public_path__ + "assets/img/1608.jpg?764f4c3a91e00c831095a0eee7956abd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1608.jpg
// module id = 1114
// module chunks = 0